import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function RefreshIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M12 2V4C16.4111 4 20 7.58887 20 12C20 16.4111 16.4111 20 12 20C7.58887 20 4 16.4111 4 12C4 9.94458 4.77808 8.00562 6.17786 6.52197L7.1045 10.6592L9.05567 10.2217L7.41602 2.89453L0.0869141 4.53418L0.524414 6.48535L4.28411 5.64453C2.80749 7.43188 1.99999 9.656 1.99999 12C1.99999 17.5137 6.48632 22 12 22C17.5137 22 22 17.5137 22 12C22 6.48633 17.5137 2 12 2Z",
    fill: "currentColor"
  }));
}